import { touchCommerceID } from './../constants/touchCommerceInfo';
import api from "./../service/apiService";
import { apiUrl } from "./../constants/apiUrl";
import {logKafka} from './../service/logService';
import { InHomeUtils } from './../util/inhomeUtils';

export const setChatVariable = (lqData) => {
    window.aimsZip = lqData.zip;
    window.runtimeChatLib = "1";
    window.aimsSession = lqData.session;
    window.aimsState = lqData.state;
    window.aimsSpecialState = lqData.state;
    window.Order_Flow = lqData.orderFlow;
    if (lqData.creditflow != null) {
        window.aimsChatCreditFlow = lqData.creditflow;
    }
    if (lqData.vendorName === "RedVentures") {
        window.RedVentures = "Y"
    }
    else if (lqData.vendorName === "Clearlink") {
        window.Clearlink = "Y"
    }
}

export const setCustomerInfoTC = (lqData) => {
    if (typeof setCustomerInfo !== "undefined") {
        window.setCustomerInfo('STATE', lqData.state);
        window.setCustomerInfo('SPECIAL STATE', lqData.state);
        window.setCustomerInfo('APPLICABLE_SEVICES', lqData.servAvail);
        window.setCustomerInfo('NEW_CUST_ADDRESS', lqData.addrString + " " + lqData.state + " " + lqData.zip);
        window.setCustomerInfo('LOCALIZATION_DETAILS', lqData.addrString + " " + lqData.state + " " + lqData.zip);
        window.setCustomerInfo('ADDRESS_ID', lqData.addressId);
        window.setCustomerInfo('VENDOR_NAME', lqData.vendorName);
        window.setCustomerInfo('CHATMULTIUSECOUPON', lqData.chatMultiUseCouponEligible);
        window.setCustomerInfo('ISGIGSTANDALONEONCART',lqData.isGigoncartStandalone);
    }
}

const getEncryptionChat = (billingName, serviceAddress, btn, billingAddress,addressId) => {
    let request = {
        billingAddress,
        serviceAddress,
        btn,
        billingName,
        addressId
    };
    return JSON.stringify(request);
};

export const setExtraCustomerInfoTC = (lqData) => {

    if (typeof setExtraCustomerInfo !== "undefined") {
        if (apiUrl().chatEncry === "Y") {
            const url = apiUrl().chatEncrypt;
            const billingName = lqData.bName || "";
            const serviceAddress = lqData.srvAdr || "";
            const btn = lqData.BTN || "";
            const billingAddress = lqData.billAddr || lqData.srvAdr||  "";
            const addressId = lqData.addressId ||  "";
            // if (lqData.bName !== "undefined" && lqData.bName !== null)
            //     billingName = lqData.bName;
            // if (lqData.srvAdr !== "undefined" && lqData.srvAdr !== null)
            //     serviceAddress = lqData.srvAdr;
            // if (lqData.BTN !== "undefined" && lqData.BTN !== null)
            //     btn = lqData.BTN;
            // if (lqData.billAddr !== "undefined" && lqData.billAddr !== null && lqData.billAddr !== "")
            //     billingAddress = lqData.billAddr;
            // else if (lqData.srvAdr !== "undefined" && lqData.srvAdr !== null)
            //     billingAddress = lqData.srvAdr;
            api(url, "POST", getEncryptionChat(billingName, serviceAddress, btn, billingAddress, addressId))
                .then(response => {
                    if (response.meta.code === 200.01) {
                        window.setExtraCustomerInfo('NAME', "ENCR:" + response.data.billingName)
                        window.setExtraCustomerInfo('CustomerServiceAddress', "ENCR:" + response.data.serviceAddress)
                        window.setExtraCustomerInfo('CustomerBillingAddress', "ENCR:" + response.data.billingAddress)
                        window.setExtraCustomerInfo('Customer_BTN', "ENCR:" + response.data.btn)
                        window.setExtraCustomerInfo('ADDRESS_ID', "ENCR:" + response.data.addressId)
                        NonEncrypteChat(lqData, true);
                    }
                    else
                        NonEncrypteChat(lqData, false);

                })
                .catch(error => {
                    NonEncrypteChat(lqData, false);
                });
        }
        else {
            NonEncrypteChat(lqData, false);
        }
    }
}

export const NonEncrypteChat = (lqData, enctypt) => {
    window.setExtraCustomerInfo('ZIP_CODE', lqData.zip);
    window.setExtraCustomerInfo('DOTCOM_SESSIONID', lqData.session);
    window.setExtraCustomerInfo('aimsInfo', 'QUICK NC');
    window.setExtraCustomerInfo('GlobalSessionID', lqData.globalID);
    window.setExtraCustomerInfo('Source Page', 'Accordion New Connect flow');
    if (/Tablet|iPad/i.test(navigator.userAgent.toLowerCase())) {
        window.setExtraCustomerInfo('IsTablet', 'Y');
    } else {
        window.setExtraCustomerInfo('IsTablet', 'N');
    }
    window.setExtraCustomerInfo('VisionAccountId', '');

    if(InHomeUtils.isNotNull(lqData.couponFlowType) && lqData.couponFlowType!=="Employee" && lqData.couponFlowType!=="Retiree"){
        window.setExtraCustomerInfo('VZ_CONNECTIONS_DISCOUNT', 'Y');
    }
    if (lqData.creditCode !== "undefined" && lqData.creditCode !== null)
        window.setExtraCustomerInfo('Credit_Fail_Id', lqData.creditCode);
    if (lqData.crv !== "undefined" && lqData.crv !== null)
        window.setExtraCustomerInfo('CRV_Number', lqData.crv);
    if (lqData.fiosReady !== "undefined" && lqData.fiosReady !== null)
        window.setExtraCustomerInfo('FiOS Ready', lqData.fiosReady);
    if (lqData.fiosSelfInstall !== "undefined" && lqData.fiosSelfInstall !== null)
        window.setExtraCustomerInfo('FiOS Self install', lqData.fiosSelfInstall);
    if (lqData.quantumEligible !== "undefined" && lqData.quantumEligible !== null)
        window.setExtraCustomerInfo('Quantum Eligible', lqData.quantumEligible);
    if (enctypt !== true) {
        if (lqData.bName !== "undefined" && lqData.bName !== null)
            window.setExtraCustomerInfo('NAME', lqData.bName);
        if (lqData.srvAdr !== "undefined" && lqData.srvAdr !== null)
            window.setExtraCustomerInfo('CustomerServiceAddress', lqData.srvAdr);
        if (lqData.billAddr !== "undefined" && lqData.billAddr !== null && lqData.billAddr !== "")
            window.setExtraCustomerInfo('CustomerBillingAddress', lqData.billAddr);
        else if (lqData.srvAdr !== "undefined" && lqData.srvAdr !== null)
            window.setExtraCustomerInfo('CustomerBillingAddress', lqData.srvAdr);
        if (lqData.BTN !== "undefined" && lqData.BTN !== null)
            window.setExtraCustomerInfo('Customer_BTN', lqData.BTN);
        if (lqData.srcPge !== "undefined" && lqData.srcPge !== null) {
            window.setExtraCustomerInfo('SOURCE_PAGE', lqData.srcPge);
            window.setExtraCustomerInfo('other', lqData.orderFlow);
        }
    }
    setCartChat(lqData.cartData,lqData.chatEnable, lqData.chatMultiUseCouponEligible, lqData.session);
}

export const setCartChat = async (cartData, reinitcall, chatMultiUseCouponEligible, visitId) => {
    let params = new URLSearchParams(window.location.search);
    let ChatQS = params.get('chat'); 
    
    if (typeof setExtraCustomerInfo !== "undefined") {
        window.setExtraCustomerInfo('PRODUCTS_IN_CART', InHomeUtils.isNotNull(cartData) ? cartData[0] : "");        
        if (typeof reInit !== "undefined" && reinitcall !== "undefined") {
            if ((reinitcall === true) || (ChatQS!=null && ChatQS==="Y"))
            {
                //no need to call 
            }
            else
            {
                window.reInit(); // (chatMultiUseCouponEligible && chatMultiUseCouponEligible === 'Y' )? window.reInit(38315384) : window.reInit();
                // window.refreshChatHashTag();
                setTimeout (() => {
                    if(window.tcData && window.tcData.VENDOR_NAME) {
                        logKafka("VENDOR", "Details", JSON.stringify(window.tcData), apiUrl().kafkaErrorAppLogs, "applogs", visitId);
                    }
                }, 1000);
            }
        }
        
    }
}

export const getEnvName = () => {
    var host = window.location.host;
    if (host === ATOM_CONST.SITURL) {
        return "SIT";
    } else if (host === ATOM_CONST.UATURL) {
        return "UAT";
    } else if (host === ATOM_CONST.STAGEURL) {
        return "STAGE";
    } else if (host === ATOM_CONST.PILOTURL) {
        return "PILOT";
    } else if (host === ATOM_CONST.PREPROD) {
        return "PREPROD";
    } else if (host === ATOM_CONST.PRODURL || host === ATOM_CONST.PRODEASTURL || host === ATOM_CONST.ESPANOL) {
        return "PROD";
    } else if (host === ATOM_CONST.NTE1URL) {
        return "NTE1";
    } else if (host === ATOM_CONST.NTE3URL) {
        return "NTE3";
    } else if (host === ATOM_CONST.NTE4URL) {
        return "NTE4";
    }
    // else if (host === ATOM_CONST.ESPANOL) {
    //     return "ESPANOL";
    // }
     else if (host === ATOM_CONST.NTE5URL) {
        return "NTE5";
    } else {
        return "LOCAL";
    }
};

const ATOM_CONST = {
    PRODURL: "www.verizon.com",
    PRODEASTURL: "wwwordering-prod-east-yz.vpc.verizon.com",
    STAGEURL: "www98.verizon.com",
    PILOTURL: "orderinglite.verizon.com",
    PREPROD: "preprod-east-gz.vpc.verizon.com",
    SITURL: "wwwawssit.ebiz.verizon.com",
    UATURL: "wwwawsuat.ebiz.verizon.com",
    NTE1URL: "wwwnte1aws.ebiz.verizon.com",
    NTE3URL: "wwwnte3aws.ebiz.verizon.com",
    NTE4URL: "wwwnte4aws.ebiz.verizon.com",
    NTE5URL: "wwwnte5aws.ebiz.verizon.com",
    ESPANOL: "espanol.verizon.com",
    LOCALURL: "localhost:3000"
};

export const isGigSpeedonCart = (cartData, lqstate) => {
    let product=""; let isGigSpeedonCart=false;let isbundleOncart=false;
    try{
       if (cartData !== undefined && cartData !== null) {
        if(cartData.cartOrderDetail !== undefined && cartData.cartOrderDetail.bundleId !== undefined && 
            cartData.cartOrderDetail.bundleId=== null && !cartData.cartOrderDetail.bundle){
                isbundleOncart =false;
        }
        else 
        isbundleOncart =true;

        cartData.cartData[0] !== undefined && cartData.cartData[0].serviceHeaders.servicehead.map(key => {
            if (key.editLink !== null && key.editLink.indexOf("data") >= 0) {
            if (key.prodName.indexOf("Gigabit") >= 0)
                isGigSpeedonCart=true;            
        }
        });
  }
         }
                catch(e){
                    return false;
                }
  

  if(!isbundleOncart && isGigSpeedonCart){
      return true;
  }    
  else 
    return false;

}
export const setCartInfo = async (cartData, lqstate, appData,reinitcall,isEcFlow = false) => {
    let nrc = cartData.cartHeader[0] !== undefined ? cartData.cartHeader[0].totalNrcPrice : "0.00";
    let totalRC = (cartData.cartHeader[0] !== undefined ? cartData.cartHeader[0].monthlyRcPrice : "0.00");
    let MON = appData.mon_no;
    let visitID = appData.visitId;
    try
    {
        totalRC = totalRC.replace("$","");
        totalRC=parseFloat(totalRC*100).toFixed(2);        
        nrc=nrc.replace("$","");
        nrc=parseFloat(nrc*100).toFixed(2);
    }
    catch(e){}
    let productsold = "";
    cartData.cartData[0] !== undefined && cartData.cartData[0].serviceHeaders.servicehead.map(key => {
        if (key.editLink !== null && key.editLink.indexOf("data") >= 0) {
            if (productsold.indexOf("FiOS Internet") >= 0)
                productsold = productsold;
            else
                productsold = (productsold === "") ? "FiOS Internet" : productsold + ",FiOS Internet";
        }
        else if (key.editLink !== null && key.editLink.indexOf("tv") >= 0) {
            if (productsold.indexOf("FiOS TV") >= 0)
                productsold = productsold;
            else
                productsold = (productsold === "") ? "FiOS TV" : productsold + ",FiOS TV";
        }
        else if (key.editLink !== null && key.editLink.indexOf("voice") >= 0) {
            if (productsold.indexOf("FiOS Voice") >= 0)
                productsold = productsold;
            else
                productsold = (productsold === "") ? "FiOS Voice" : productsold + ",FiOS Voice";
        }
        return productsold;
    });
    window.aimsTrackingVar = "PROD_SOLD=" + productsold + "-" + "DOTCOM_SESS_ID=" + visitID + "-" + "NRC=" + nrc + "-" + "MRC=" + totalRC + "-" + "DOTCOM_ORDER_ID=" + MON + "-" + "MON=" + MON;

    // Here build the order object
    let params = new URLSearchParams(window.location.search);
    let ChatQS = params.get('chat'); 
    
    if (typeof setExtraCustomerInfo !== "undefined" ) {
        orderObject(cartData, lqstate, appData, isEcFlow);  
        if (typeof reInit !== "undefined" && reinitcall !== "undefined" ) {
            if ((reinitcall === true) || (ChatQS!=null && ChatQS==="Y"))
            {
                //no need ot call 
            }
            else
            {
               // window.reInit();
                try {
                    //Live person Chat Changes
                    let submitChatInfo = false;
                    if (InHomeUtils.isNotNull(lqstate.runtimeKey) && InHomeUtils.isNotEmpty(lqstate.runtimeKey.isLPCEnabled) && lqstate.runtimeKey.isLPCEnabled === "Y") {
                        let chatInfoDetails = getChatInfoDetails(appData.visitId, appData.visitorId);
                        Promise.all([chatInfoDetails]).then(function (values) {
                            if (InHomeUtils.isNotNull(values[0]) && InHomeUtils.isNotNull(values[0].chatInfo) && InHomeUtils.isNotNull(values[0].chatInfo.submitChat) && values[0].chatInfo.submitChat === "Y") {
                                submitChatInfo = true;
                            }
                            window.callChatOrderConf(submitChatInfo);
                        });

                    }
                    else {
                        window.callChatOrderConf(submitChatInfo);
                    }

                } catch (e) { }
            }
        }
        
    }
}

const getChatInfoDetails = (visitId, visitorId) => {
    try {
        let url = apiUrl().chatDetails + "?visitorId=" + visitorId + "&visitId=" + visitId + "&verifySubmit=Y";
        return new Promise((resolve, reject) => {
            api(url, 'GET', '').then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && 
                InHomeUtils.isNotNull(response.chatInfo) && InHomeUtils.isNotNull(response.chatInfo !== null) ) {
                    resolve(response);
                }
                else
                    resolve(false);
            }).catch(error => {
                // logKafka("VENDOR", "Details", JSON.stringify(error.message), apiUrl().kafkaErrorAppLogs, "applogs", visitId);                
            });
        });
    }
    catch (ex) {

    }
}

const orderObject = (cartData, lqstate, appData, isEcFlow = false) => {
    let caValue = ''; let totalprice = ''; let qty = ''; let c1Value = ''; let bundleName = '';
    let discountvalue = ''; let prodtype = ''; let bundleattr = '';
    let prow = ''; let agreementPlanName = ''; let tv = ''; let data = ''; let voice = '';
    if (cartData !== undefined && cartData !== null) {
        if (cartData.cartData[0] !== undefined && cartData.cartData[0] !== null &&
            cartData.cartData[0].serviceHeaders !== undefined && cartData.cartData[0].serviceHeaders !== null) {
            if (cartData.cartData[0].serviceHeaders.title !== undefined && cartData.cartData[0].serviceHeaders.title != null) {
                prow = cartData.cartData[0].serviceHeaders.title + ',';
                caValue = caValue + 'standard-' + cartData.cartData[0].serviceHeaders.title + ',';
                bundleName = cartData.cartData[0].serviceHeaders.title;
            }
            if (totalprice === '' || totalprice === undefined) {
                if (cartData.cartData[0].serviceHeaders.totalPrice !== undefined && cartData.cartData[0].serviceHeaders.totalPrice !== null) {
                    totalprice = cartData.cartData[0].serviceHeaders.totalPrice.replace('$', '') + ',';
                }
            }
            if (cartData.cartData[0].serviceHeaders.title !== undefined &&
                cartData.cartData[0].serviceHeaders.title !== null) {
                if (cartData.cartData[0].serviceHeaders.title.indexOf("Triple") >= 0) {
                    bundleattr = "Triple - ";
                }
                else if (cartData.cartData[0].serviceHeaders.title !== null && cartData.cartData[0].serviceHeaders.title.indexOf("Double") >= 0) {
                    bundleattr = "Double - ";
                }
                else {
                    bundleattr = "Standalone - ";
                }
            }
            else {
                bundleattr = "Standalone - ";
            }
            if (cartData.cartData[0].serviceHeaders !== undefined && cartData.cartData[0].serviceHeaders != null
                && cartData.cartData[0].serviceHeaders.servicehead !== undefined && cartData.cartData[0].serviceHeaders.servicehead !== null) {
                cartData.cartData[0].serviceHeaders.servicehead.map(key => {
                    if (key.editLink !== null && key.editLink.indexOf("data") >= 0) {
                        prow = prow + key.prodName + ',';
                        caValue = caValue + 'standard-' + key.prodName + ',';
                        data = 'fdata';
                        if (key.price === null || key.price === undefined) {
                            totalprice = totalprice + '0,';
                        }
                        else
                            totalprice = totalprice + key.price.replace('$', '') + ',';
                        qty = qty + '1,';
                        c1Value = c1Value + 'standard,';
                        if (key.prodType !== null || key.prodType !== undefined) {
                            prodtype = prodtype + key.prodType + ',';
                        }

                    }
                    else if (key.editLink !== null && key.editLink.indexOf("tv") >= 0 &&
                        !(key.prodName.indexOf("agreement") >= 0)) {
                        prow = prow + key.prodName + ',';
                        caValue = caValue + 'standard-' + key.prodName + ',';
                        qty = qty + '1,';
                        c1Value = c1Value + 'standard,';
                        tv = 'ftv';
                        if (key.price === null || key.price === undefined) {
                            totalprice = totalprice + '0,';
                        }
                        else
                            totalprice = totalprice + key.price.replace('$', '') + ',';
                        if (key.prodType !== null || key.prodType !== undefined) {
                            prodtype = prodtype + key.prodType + ',';
                        }
                    }
                    else if (key.editLink !== null && key.editLink.indexOf("voice") >= 0) {
                        prow = prow + key.prodName + ',';
                        caValue = caValue + 'standard-' + key.prodName + ',';
                        qty = qty + '1,';
                        c1Value = c1Value + 'standard,';
                        if (key.price === null || key.price === undefined) {
                            totalprice = totalprice + '0,';
                        }
                        else
                            totalprice = totalprice + key.price.replace('$', '') + ',';
                        if (key.prodType !== null || key.prodType !== undefined) {
                            prodtype = prodtype + key.prodType + ',';
                        }
                        voice = "fphone";
                    }
                    else if (key.editLink !== null && key.editLink.indexOf("Plan") >= 0
                        && key.prodName.indexOf("agreement") >= 0) {
                        //prow=prow + key.prodName+',';
                        agreementPlanName = key.prodName;
                        if (key.price === null || key.price === undefined) {
                            totalprice = totalprice + '0,';
                        }
                        else
                            totalprice = totalprice + key.price.replace('$', '') + ',';
                        if (key.prodType !== null || key.prodType !== undefined) {
                            prodtype = prodtype + key.prodType + ',';
                        }
                    }
                    else {
                        prow = prow + key.prodName + ',';
                        caValue = caValue + 'standard-' + key.prodName + ',';
                        qty = qty + '1,';
                        c1Value = c1Value + 'standard,';
                        if (key.prodType !== null || key.prodType !== undefined) {
                            prodtype = prodtype + key.prodType + ',';
                        }
                        if (key.price === null || key.price === undefined) {
                            totalprice = totalprice + '0,';
                        }
                        else
                            totalprice = totalprice + key.price.replace('$', '') + ',';
                    }
                });
            }
        }
        if (cartData.cartData[0].equipments !== undefined &&
            cartData.cartData[0].equipments !== null &&
            cartData.cartData[0].equipments.equipment !== undefined &&
            cartData.cartData[0].equipments.equipment !== null) {
            cartData.cartData[0].equipments.equipment.map(key => {
                if (key.editLink !== null && key.editLink.indexOf("recording") >= 0) {
                    prow = prow + key.prodName + ',';
                    caValue = caValue + 'standard-' + key.prodName + ',';
                    qty = qty + '1,';
                    c1Value = c1Value + 'standard,';
                    if (key.prodType !== null || key.prodType !== undefined) {
                        prodtype = prodtype + key.prodType + ',';
                    }
                    if (key.price === null || key.price === undefined) {
                        totalprice = totalprice + '0,';
                    }
                    else
                        totalprice = totalprice + key.price.replace('$', '') + ',';
                }
                else if (key.editLink !== null && key.editLink.indexOf("Tv") >= 0) {
                    prow = prow + key.prodName + ',';
                    caValue = caValue + 'standard-' + key.prodName + ',';
                    qty = qty + '1,';
                    c1Value = c1Value + 'standard,';
                    if (key.prodType !== null || key.prodType !== undefined) {
                        prodtype = prodtype + key.prodType + ',';
                    }
                    if (key.price === null || key.price === undefined) {
                        totalprice = totalprice + '0,';
                    }
                    else
                        totalprice = totalprice + key.price.replace('$', '') + ','
                }
                else if (key.editLink !== null && key.editLink.indexOf("Router") >= 0) {
                    prow = prow + key.prodName + ',';
                    caValue = caValue + 'standard-' + key.prodName + ',';
                    qty = qty + '1,';
                    c1Value = c1Value + 'standard,';
                    if (key.prodType !== null || key.prodType !== undefined) {
                        prodtype = prodtype + key.prodType + ',';
                    }
                    if (key.price === null || key.price === undefined) {
                        totalprice = totalprice + '0,';
                    }
                    else
                        totalprice = totalprice + key.price.replace('$', '') + ','
                }
            });
        }

        if (cartData.cartData[0].channel !== undefined
            && cartData.cartData[0].channel !== null) {
            if (cartData.cartData[0].channel.channelsProds !== undefined &&
                cartData.cartData[0].channel.channelsProds !== null) {
                cartData.cartData[0].channel.channelsProds.map(key => {
                    prow = prow + key.prodName + ',';
                    caValue = caValue + 'standard-' + key.prodName + ',';
                    qty = qty + '1,';
                    c1Value = c1Value + 'standard,';
                    if (key.prodType !== null || key.prodType !== undefined) {
                        prodtype = prodtype + key.prodType + ',';
                    }
                    if (key.price === null || key.price === undefined) {
                        totalprice = totalprice + '0,';
                    }
                    else
                        totalprice = totalprice + key.price.replace('$', '') + ','
                });
            }
            if (cartData.cartData[0].channel.channelstitle !== undefined &&
                cartData.cartData[0].channel.channelstitle !== null) {
                prow = prow + cartData.cartData[0].channel.channelstitle + ',';
                caValue = caValue + 'standard-' + cartData.cartData[0].channel.channelstitle + ',';
            }
            if (cartData.cartData[0].channel.channelsTotalprice !== undefined &&
                cartData.cartData[0].channel.channelsTotalprice !== null) {
                totalprice = totalprice + cartData.cartData[0].channel.channelsTotalprice.replace('$', '') + ','
            }
        }
        if (cartData.cartData[0].internet !== undefined &&
            cartData.cartData[0].internet !== null &&
            cartData.cartData[0].internet.internetProds !== undefined &&
            cartData.cartData[0].internet.internetProds !== null) {
            cartData.cartData[0].internet.internetProds.map(key => {
                prow = prow + key.prodName + ',';
                caValue = caValue + 'standard-' + key.prodName + ',';
                qty = qty + '1,';
                c1Value = c1Value + 'standard,';
                if (key.prodType !== null || key.prodType !== undefined) {
                    prodtype = prodtype + key.prodType + ',';
                }
                if (key.price === null || key.price === undefined) {
                    totalprice = totalprice + '0,';
                }
                else
                    totalprice = totalprice + key.price.replace('$', '') + ','

            });
        }
        if (cartData.cartData[0].listing !== undefined &&
            cartData.cartData[0].listing !== null &&
            cartData.cartData[0].listing.listingProds !== undefined &&
            cartData.cartData[0].listing.listingProds !== null) {
            cartData.cartData[0].listing.listingProds.map(key => {
                prow = prow + key.prodName + ',';
                caValue = caValue + 'standard-' + key.prodName + ',';
                qty = qty + '1,';
                c1Value = c1Value + 'standard,';
                if (key.prodType !== null || key.prodType !== undefined) {
                    prodtype = prodtype + key.prodType + ',';
                }
                if (key.price === null || key.price === undefined) {
                    totalprice = totalprice + '0,';
                }
                else if (key.price.indexOf("Waived") >= 0)
                    totalprice = totalprice + '0,';
                else
                    totalprice = totalprice + key.price.replace('$', '') + ','
            });
        }
        if (cartData.cartData[0].oneTimeCharge !== undefined &&
            cartData.cartData[0].oneTimeCharge !== null &&
            cartData.cartData[0].oneTimeCharge.onetimecharge !== undefined &&
            cartData.cartData[0].oneTimeCharge.onetimecharge !== null) {
            cartData.cartData[0].oneTimeCharge.onetimecharge.map(key => {
                prow = prow + key.prodName + ',';
                caValue = caValue + 'standard-' + key.prodName + ',';
                qty = qty + '1,';
                c1Value = c1Value + 'standard,';
                if (key.prodType !== null || key.prodType !== undefined) {
                    prodtype = prodtype + key.prodType + ',';
                }
                if (key.price === null || key.price === undefined) {
                    totalprice = totalprice + '0,';
                }
                else if (key.price.indexOf("Waived") >= 0)
                    totalprice = totalprice + '0,';
                else
                    totalprice = totalprice + key.price.replace('$', '') + ','
            });
        }

        if (cartData.cartData[0].rewardOffers !== undefined &&
            cartData.cartData[0].rewardOffers !== null &&
            cartData.cartData[0].rewardOffers.rewardOffers !== undefined &&
            cartData.cartData[0].rewardOffers.rewardOffers !== null) {
            cartData.cartData[0].rewardOffers.rewardOffers.map(key => {
                prow = prow + key.promoText.replace('$', '') + ',';
                caValue = caValue + 'standard-' + key.promoText.replace('$', '') + ',';
                qty = qty + '1,';
                c1Value = c1Value + 'standard,';
                if (key.price === null || key.price === undefined) {
                    totalprice = totalprice + '0,';
                }
                else if (key.price.indexOf("Waived") >= 0)
                    totalprice = totalprice + '0,';
                else
                    totalprice = totalprice + key.price.replace('$', '') + ','
            });
        }
        if (cartData.cartData[0].Promotions !== undefined &&
            cartData.cartData[0].Promotions !== null &&
            cartData.cartData[0].Promotions.promotions !== undefined &&
            cartData.cartData[0].Promotions.promotions !== null) {
            cartData.cartData[0].Promotions.promotions.map(key => {
                prow = prow + key.promoText.replace('$', '') + ',';
                caValue = caValue + 'standard-' + key.promoText.replace('$', '') + ',';
                qty = qty + '1,';
                c1Value = c1Value + 'standard,';
            });
        }
    }
    if (agreementPlanName !== undefined && agreementPlanName !== null) {
        prow = prow + agreementPlanName + ',';
        caValue = caValue + 'standard-' + agreementPlanName + ',';
    }
    bundleattr = bundleattr + voice + "+" + data + "+" + tv;

    if (isEcFlow) {
        window.order = {
            pr: prow,
            //bd: '', // we don't have category concept in atom to bring this value- part of dot com redesign this value no longer.
            ca: caValue,
            pc: totalprice,
            qn: qty,
            c1: c1Value,
            sr: '5',//new service always 5 as per bau
            sy: '',//have to code to city value DataValueSY(cartData),
            sa: lqstate.response.state,//have to code to get state value  DataValueSA(cartData),
            sz: lqstate.response.zipCode,//have to code to get zip code DataValueSZ(cartData),
            ds: discountvalue,//have to code to get discount value- voice product discount minus with total bundle price check logic in bau,
            po: bundleName,//DataValuePO(cartData),
            oi: appData.visitId,//DataValueOI(cartData),    
            ot: 'EC',//always EC
            attr1: bundleattr,//dynamically have to do it
            prodTypes: prodtype,// DataValuePRODTYPES(cartData),

        }
    }
    else {
        window.order = {
            pr: prow,
            //bd: '', // we don't have category concept in atom to bring this value- part of dot com redesign this value no longer.
            ca: caValue,
            pc: totalprice,
            qn: qty,
            c1: c1Value,
            sr: '5',//new service always 5 as per bau
            sy: lqstate.selectedState.altCity,//have to code to city value DataValueSY(cartData),
            sa: lqstate.selectedState.state,//have to code to get state value  DataValueSA(cartData),
            sz: lqstate.selectedState.zip,//have to code to get zip code DataValueSZ(cartData),
            ds: discountvalue,//have to code to get discount value- voice product discount minus with total bundle price check logic in bau,
            po: bundleName,//DataValuePO(cartData),
            oi: appData.visitId,//DataValueOI(cartData),    
            ot: 'NC',//always NC
            attr1: bundleattr,//dynamically have to do it
            prodTypes: prodtype,// DataValuePRODTYPES(cartData),

        }
    }
}

export const creditInfoUpdate = async (status, persData, crv) => {
    if (typeof setCustomerInfo !== "undefined") {
        if (status === "SUCCESS") {
            window.aimsChatCreditFlow = "0";
            window.setCustomerInfo('Credit_Fail_Id', '0');
            window.setCustomerInfo('CRV_Number', crv);
            window.setCustomerInfo('NAME', persData.contactInfo.fName + '' + persData.contactInfo.lName);
            window.setCustomerInfo('creditCheckFailTC', '0');
            if (typeof refreshTCChat !== "undefined") {
                window.refreshTCChat();
            }
        } else if (status === "FAILURE") {
            window.aimsChatCreditFlow = "1";
            window.setCustomerInfo('Credit_Fail_Id', '1');
            window.setCustomerInfo('CRV_Number', crv);
            window.setCustomerInfo('NAME', persData.contactInfo.fName + '' + persData.contactInfo.lName);
            window.setCustomerInfo('creditCheckFailTC', '1');
            if (typeof refreshTCChat !== "undefined") {
                window.refreshTCChat();
            }
        }
    }
}

export const invokeTouchCommerce = async (section) => {
    var tcSection = touchCommerceID.filter(p => (p.SectionName === section.toUpperCase()) || (typeof p.ServiceType !== "undefined" && p.ServiceType === section));
    let env = getEnvName();
    
    if (env === "STAGE" || env === "PILOT" || env === "PREPROD" || env === "LOCAL" || env === "PROD") {
        if (typeof tcSection !== "undefined" && tcSection !== null && tcSection.length > 0 && typeof reInit !== "undefined" && typeof Inq !== "undefined") {
            window.reInit(tcSection[0].TCID);
        }
    }
}

export const invokeChatReinit = async () => {
    try {
        if (typeof setCustomerInfo !== "undefined") {
            window.reInit();
            window.refreshChatHashTagNC();
        }
    }
    catch (ex) {
        console.error(ex);
    }
}
